import { Component, OnInit } from '@angular/core'
import { UserPreferences } from '@tv3/store/user-preferences/user-preferences.model'
import { Store } from '@ngrx/store'
import * as fromRoot from '@tv3/store/state'
import { selectUserPreferences } from '@tv3/store/user-preferences/user-preferences.selectors'
import { UpdateUserPreferences } from '@tv3/store/user-preferences/user-preferences.actions'
import { selectSome, Destroyable, untilDestroy } from '@tokeet/tv3-platform'

@Component({
  selector: 'app-default-route-indicator',
  templateUrl: './default-route-indicator.component.html',
  styleUrls: ['./default-route-indicator.component.scss'],
})
export class DefaultRouteIndicatorComponent extends Destroyable implements OnInit {
  route = window.location.pathname

  userPreference: UserPreferences
  isDefault = false

  constructor(private store: Store<fromRoot.State>) {
    super()
  }

  ngOnInit() {
    this.store.pipe(selectSome(selectUserPreferences), untilDestroy(this)).subscribe((userPref: UserPreferences) => {
      this.userPreference = userPref
      this.isDefault = this.userPreference.defaultRoute === this.route
    })
  }

  setAsDefault() {
    const payload = {
      id: this.userPreference.id,
      form: {
        default_route: this.isDefault ? '' : this.route,
      },
    }
    this.store.dispatch(UpdateUserPreferences(payload))
  }
}
